import EdgeProgressBar from "@components/progress/edge_progress_bar/edge_progress_bar"

export default function ProgressBar(opts={}){
    BaseConstructor.call(this)
    let {container,timer} = opts
    let elements = {}
    let context = this
    let progressBar

    this.generate = () =>{
        progressBar = new EdgeProgressBar({
            container: 'section',
            duration: timer,
            move_factor: 100,
            options:{
                color: 'var(--gray-dark)',
                size: 'xs'
            },
            label:{
                content: generateLabelContent(),
                position: 'left'
            }
        })
        progressBar.generate()
    }

    this.update = () =>{

    }

    this.reload = () =>{

    }

    this.start = _ =>{
        progressBar.updateLabelContent(generateLabelContent())
        progressBar.move()
    }

    this.stop = _ =>{

    }

    const generateLabelContent = () =>{
        return `<div style="font-size:small;white-space: nowrap;"><i class="fas fa-clock mr-2"></i><b><i>${moment().format('DD/MM/YYYY H:m')}</i></b></div>`
    }
}

ProgressBar.prototype = Object.create(BaseConstructor.prototype)